import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createSchedule,
  deleteSchedule,
  getScheduleDetail,
  getScheduleList,
  updateSchedule,
  updateScheduleIndex,
} from '../../api/constlink';
import {
  createScheduleAsync,
  CREATE_SCHEDULE,
  deleteScheduleAsync,
  DELETE_SCHEDULE,
  getScheduleListAsync,
  GET_SCHEDULE_LIST,
  updateScheduleAsync,
  UPDATE_SCHEDULE,
  getScheduleDetailAsync,
  GET_SCHEDULE_DETAIL,
  updateScheduleIndexAsync,
  UPDATE_SCHEDULE_INDEX,
} from './actions';
import { Schedule, ScheduleActionType } from './types';

function* getScheduleListSaga(
  action: ReturnType<typeof getScheduleListAsync.request>,
) {
  try {
    const schedules: Schedule[] = yield call(getScheduleList, action.payload);
    yield put(getScheduleListAsync.success(schedules));
  } catch (e: any) {
    yield put(getScheduleListAsync.failure(e));
  }
}

function* createScheduleSaga(
  action: ReturnType<typeof createScheduleAsync.request>,
) {
  try {
    const schedule: Schedule = yield call(createSchedule, action.payload);
    yield put(createScheduleAsync.success(schedule));
  } catch (e: any) {
    yield put(createScheduleAsync.failure(e));
  }
}

function* getScheduleDetailSaga(
  action: ReturnType<typeof getScheduleDetailAsync.request>,
) {
  try {
    const schedule: Schedule = yield call(getScheduleDetail, action.payload);
    yield put(getScheduleDetailAsync.success(schedule));
  } catch (e: any) {
    yield put(getScheduleDetailAsync.failure(e));
  }
}

function* updateScheduleSaga(
  action: ReturnType<typeof updateScheduleAsync.request>,
) {
  try {
    const scheduleActionType: ScheduleActionType = yield call(
      updateSchedule,
      action.payload,
    );
    yield put(updateScheduleAsync.success(scheduleActionType));
  } catch (e: any) {
    yield put(updateScheduleAsync.failure(e));
  }
}

function* deleteScheduleSaga(
  action: ReturnType<typeof deleteScheduleAsync.request>,
) {
  try {
    const scheduleId: number = yield call(deleteSchedule, action.payload);
    yield put(deleteScheduleAsync.success(scheduleId));
  } catch (e: any) {
    yield put(deleteScheduleAsync.failure(e));
  }
}

function* updateScheduleIndexSaga(
  action: ReturnType<typeof updateScheduleIndexAsync.request>,
) {
  try {
    const schedule: Schedule = yield call(updateScheduleIndex, action.payload);
    yield put(updateScheduleIndexAsync.success(schedule));
  } catch (e: any) {
    yield put(updateScheduleIndexAsync.failure(e));
  }
}

export function* schedulesSaga() {
  yield takeLatest(GET_SCHEDULE_LIST, getScheduleListSaga);
  yield takeLatest(CREATE_SCHEDULE, createScheduleSaga);
  yield takeLatest(GET_SCHEDULE_DETAIL, getScheduleDetailSaga);
  yield takeLatest(UPDATE_SCHEDULE, updateScheduleSaga);
  yield takeLatest(DELETE_SCHEDULE, deleteScheduleSaga);
  yield takeLatest(UPDATE_SCHEDULE_INDEX, updateScheduleIndexSaga);
}
